import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

type UserRole = "admin" | "gc" | "sub" | "lender" | "owner" | "inspector";

const ROLE_REDIRECT: Record<UserRole, string> = {
  admin: "/admin",
  gc: "/gc-dashboard",
  sub: "/lien-waiver",
  lender: "/bank-dashboard",
  owner: "/owner-dashboard",
  inspector: "/project-inspection",
};

interface StoredUser {
  role: UserRole;
}

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles: UserRole[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const storedUser = localStorage.getItem("user");
  const user: StoredUser | null = storedUser ? JSON.parse(storedUser) : null;

  if (!user) {
    const intended = window.location.pathname + window.location.search;
    if (intended && intended !== "/") {
      sessionStorage.setItem("redirect_after_login", intended);
    }
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

interface GuestRouteProps {
  children: ReactNode;
}

export const GuestRoute = ({ children }: GuestRouteProps) => {
  const storedUser = localStorage.getItem("user");
  const user: StoredUser | null = storedUser ? JSON.parse(storedUser) : null;

  if (user?.role) {
    const to = ROLE_REDIRECT[user.role] ?? "/";
    return <Navigate to={to} replace />;
  }

  return children;
};

export default ProtectedRoute;
